// 导入封装好的axios实例
import request from './request'
import commonfun from '@/commonfun'
const net = {
  /**
   *  @param methods 请求
   *  @param url 请求地址
   *  @param params 请求参数
   *  @param headers 请求头
   *  @param baseUrl 请求地址--默认可以不传
   */
  get (methods, url, params, baseUrl) {
    const config = {
      method: methods,
      url: url,
      baseUrl: baseUrl,
      headers: {
        'Content-Type': 'application/json',
        OwnerId: commonfun.localStorage.getitem('ownerId'),
        OwnerCode: commonfun.localStorage.getitem('ownerCode'),
        UserID: commonfun.localStorage.getitem('userId'),
        Sid: commonfun.localStorage.getitem('sid'),
        qyuser: commonfun.localStorage.getitem('qyuser'),
        lang: commonfun.localStorage.getitem('lang'),
        ClientSourceType: 3
      }
    }
    if (methods === 'post' || methods === 'delete' || methods === 'put') {
      if (params) config.data = params
    } else {
      if (params) config.params = params
    }
    return request(config)
  },
  getUpload (methods, url, params, baseUrl) {
    const config = {
      method: methods,
      url: url,
      baseUrl: baseUrl,
      headers: {
        token: commonfun.localStorage.getitem('token'),
        lang: commonfun.localStorage.getitem('lang'),
        'Content-Type': 'multipart/form-data',
        FileExtension: 'jpg'
      }
    }
    if (methods === 'post' || methods === 'delete' || methods === 'put') {
      if (params) config.data = params
    } else {
      if (params) config.params = params
    }
    return request(config)
  },
  getBlob (methods, url, params, baseUrl) {
    const config = {
      method: methods,
      url: url,
      baseUrl: baseUrl,
      headers: {
        'Content-Type': 'application/json',
        OwnerId: commonfun.localStorage.getitem('ownerId'),
        OwnerCode: commonfun.localStorage.getitem('ownerCode'),
        UserID: commonfun.localStorage.getitem('userId'),
        Sid: commonfun.localStorage.getitem('sid'),
        qyuser: commonfun.localStorage.getitem('qyuser'),
        lang: commonfun.localStorage.getitem('lang'),
        ClientSourceType: 3
      },
      responseType: 'blob'
    }
    if (methods === 'post' || methods === 'delete' || methods === 'put') {
      if (params) config.data = params
    } else {
      if (params) config.params = params
    }
    return request(config)
  }
}
export default net
